var _slicedToArray = require("/builds/londonmep/pw-admin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.ReactCustomizableProgressbar = t(require("react")) : e.ReactCustomizableProgressbar = t(e.react);
}(this, function (e) {
  return function (e) {
    var t = {};

    function r(o) {
      if (t[o]) return t[o].exports;
      var n = t[o] = {
        i: o,
        l: !1,
        exports: {}
      };
      return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
    }

    return r.m = e, r.c = t, r.d = function (e, t, o) {
      r.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: o
      });
    }, r.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, r.t = function (e, t) {
      if (1 & t && (e = r(e)), 8 & t) return e;
      if (4 & t && "object" == typeof e && e && e.__esModule) return e;
      var o = Object.create(null);
      if (r.r(o), Object.defineProperty(o, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var n in e) {
        r.d(o, n, function (t) {
          return e[t];
        }.bind(null, n));
      }
      return o;
    }, r.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return r.d(t, "a", t), t;
    }, r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, r.p = "", r(r.s = 1);
  }([function (t, r) {
    t.exports = e;
  }, function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    "use strict";

    r.r(t);
    var o = r(0),
        n = r.n(o);

    var i = function i(_ref) {
      var e = _ref.radius,
          t = _ref.progress,
          r = _ref.steps,
          i = _ref.cut,
          a = _ref.rotate,
          s = _ref.strokeWidth,
          c = _ref.strokeColor,
          l = _ref.fillColor,
          u = _ref.strokeLinecap,
          f = _ref.transition,
          p = _ref.pointerRadius,
          d = _ref.pointerStrokeWidth,
          k = _ref.pointerStrokeColor,
          m = _ref.pointerFillColor,
          y = _ref.trackStrokeColor,
          b = _ref.trackStrokeWidth,
          h = _ref.trackStrokeLinecap,
          C = _ref.trackTransition,
          x = _ref.counterClockwise,
          g = _ref.inverse,
          S = _ref.initialAnimation,
          v = _ref.initialAnimationDelay,
          P = _ref.className,
          $ = _ref.children;

      var _Object = Object(o.useState)(!1),
          _Object2 = _slicedToArray(_Object, 2),
          j = _Object2[0],
          _ = _Object2[1];

      Object(o.useEffect)(function () {
        S && setTimeout(function () {
          return _(!0);
        }, v);
      }, []);

      var O = function O() {
        return S && !j ? 0 : t;
      },
          W = function W() {
        var e = p + d;
        return e > s && e > b ? 2 * e : s > b ? 2 * s : 2 * b;
      },
          R = 2 * e,
          w = R + W(),
          E = 2 * Math.PI * e,
          L = E / 360 * (360 - i);

      return n.a.createElement("div", {
        className: "RCP " + P,
        style: {
          position: "relative",
          width: w + "px"
        }
      }, n.a.createElement("svg", {
        width: w,
        height: w,
        viewBox: "0 0 ".concat(w, " ").concat(w),
        style: {
          transform: "rotate(".concat(a, "deg)")
        }
      }, b > 0 && n.a.createElement("circle", {
        cx: w / 2,
        cy: w / 2,
        r: e,
        fill: "none",
        stroke: y,
        strokeWidth: b,
        strokeDasharray: function (e, t) {
          return S && !j ? "0, " + t : "".concat(e, ", ").concat(t);
        }(L, E),
        strokeLinecap: h,
        className: "RCP__track",
        style: {
          transition: C
        }
      }), s > 0 && n.a.createElement("circle", {
        cx: w / 2,
        cy: w / 2,
        r: e,
        fill: l,
        stroke: c,
        strokeWidth: s,
        strokeDasharray: function (e, t) {
          var o = O();
          return g ? "".concat(e / r * (r - o), ", ").concat(t) : x ? "".concat(e * (o / 100), ", ").concat(t) : "".concat(e, ", ").concat(t);
        }(L, E),
        strokeDashoffset: function (e) {
          var t = O(),
              o = e / r * (r - t);
          return g ? x ? 0 : o - e : x ? -1 * o : o;
        }(L),
        strokeLinecap: u,
        className: "RCP__progress",
        style: {
          transition: f
        }
      }), p > 0 && n.a.createElement("circle", {
        cx: R,
        cy: "50%",
        r: p,
        fill: m,
        stroke: k,
        strokeWidth: d,
        className: "RCP__pointer",
        style: {
          transformOrigin: "50% 50%",
          transform: "rotate(".concat(function () {
            var e = O();
            return x ? (360 - i) / r * (r - e) : (360 - i) / r * e;
          }(), "deg) translate(").concat(W() / 2, "px)"),
          transition: f
        }
      })), $ || null);
    };

    i.defaultProps = {
      radius: 100,
      progress: 0,
      steps: 100,
      cut: 0,
      rotate: -90,
      strokeWidth: 20,
      strokeColor: "indianred",
      fillColor: "none",
      strokeLinecap: "round",
      transition: ".3s ease",
      pointerRadius: 0,
      pointerStrokeWidth: 20,
      pointerStrokeColor: "indianred",
      pointerFillColor: "white",
      trackStrokeColor: "#e6e6e6",
      trackStrokeWidth: 20,
      trackStrokeLinecap: "round",
      trackTransition: ".3s ease",
      counterClockwise: !1,
      inverse: !1,
      initialAnimation: !1,
      initialAnimationDelay: 0,
      className: ""
    }, t.default = i;
  }]);
});